export const Errors = {
    COMPONENT_WITH_STYLES_IN_BREAKPOINTS: 'COMPONENT_WITH_STYLES_IN_BREAKPOINTS',
    COMPONENT_TYPE_IS_MISSING: 'COMPONENT_TYPE_IS_MISSING',
    COMPONENTS_ARE_NOT_ON_THE_SAME_PAGE: 'COMPONENTS_ARE_NOT_ON_THE_SAME_PAGE',
    ADDING_STRINGABLE_CUSTOM_STYLE: 'ADDING_STRINGABLE_CUSTOM_STYLE',
    VARIANTS_QUERY_IDENTIFIER: 'VARIANTS_QUERY_IDENTIFIER',
    DUPLICATE_VARIANTS: 'DUPLICATE_VARIANTS'
}
